import {
  PopoverTrigger,
  PopoverContent,
  CardContent,
  Typography,
  CardHeader,
  Popover,
  Loading,
  Button,
  Card,
  Logo,
  Form,
} from '@ui/components';
import { LanguagePicker, TermsAndPolicy } from '@pages/auth/containers';
import { useAcceptConsents } from '@pages/auth/hooks';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { Info } from '@ui/components/icons';
import { Navigate } from 'react-router-dom';
import { Help } from '@shared/components';
import { Routes } from '@shared/enums';

export const AcceptConsents = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();

  const { form, onSubmit, isAcceptConsentsLoading, isConsentsLoading } = useAcceptConsents();

  if (user?.hasAllRequiredConsentsAccepted) {
    if (user.companies.length === 1) {
      return <Navigate to={`/${user?.companies[0]?.id}`} />;
    } else {
      return <Navigate to={Routes.ROOT} />;
    }
  }

  return (
    <main className="h-screen bg-cover bg-[url('../images/background.svg')] w-full">
      <header className="flex px-12 pt-4 h-14 items-center justify-between w-full">
        <Logo />
        <div className="ml-auto flex gap-4">
          <LanguagePicker />
          <Popover>
            <PopoverTrigger asChild>
              <Button variant="ghost">
                <Info />
                {t('HELP.HELP')}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="min-w-100" align="end">
              <Help />
            </PopoverContent>
          </Popover>
        </div>
      </header>

      <div className="mx-auto mt-10 pb-4 px-4 w-full max-w-[600px]">
        <Card className="p-2">
          <CardHeader>
            <Typography variant="h400">{t('AUTH.ACCEPT_CONSENTS.TITLE')}</Typography>
          </CardHeader>

          <CardContent className="flex flex-col gap-2 p-4">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
                <Loading isLoading={isConsentsLoading}>
                  <TermsAndPolicy formControl={form.control} />
                </Loading>

                <Button
                  disabled={isAcceptConsentsLoading || isConsentsLoading}
                  isLoading={isAcceptConsentsLoading}
                  size="large"
                  wide
                >
                  {t('AUTH.ACCEPT_CONSENTS.CONTINUE')}
                </Button>
              </form>
            </Form>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};
